export const blockIconsImageCollections = (
	<span className='material-symbols-outlined'>collections</span>
);
